import { LOCALHOST_ENVIRONMENT, STAGE_ENVIRONMENT } from "./model";

const useCheckEnvProtect = () => {
  const showProtect =
    process.env.NEXT_PUBLIC_NODE_ENV == LOCALHOST_ENVIRONMENT ||
    process.env.NEXT_PUBLIC_NODE_ENV == STAGE_ENVIRONMENT;
  return showProtect;
};

export default useCheckEnvProtect;

